<template>
  <div class="schedule-header">
    <div class="schedule-header__nav">
      <button
        :disabled="isLoading || !hasPrevious"
        :title="previousTitle"
        class="nav-button marker--schedule-header--previous"
        type="button"
        @click="$emit('previous')"
      >
        <i class="ddi ddi-caret-left" />
      </button>
      <button
        :disabled="isLoading || !hasNext"
        :title="nextTitle"
        class="nav-button marker--schedule-header--next"
        type="button"
        @click="$emit('next')"
      >
        <i class="ddi ddi-caret-right" />
      </button>
      <span class="label">{{ label }}</span>
      <button
        :disabled="isLoading"
        class="today-button"
        type="button"
        @click="$emit('today')"
      >
        Today
      </button>
    </div>
    <dd-button
      :color="ColorAssistant.ProjectColor"
      size="medium"
      class="marker--schedule-header--add"
      @click="$emit('add-task')"
    >
      <i class="ddi ddi-plus" />&nbsp;
      <span>New event</span>
    </dd-button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import ColorAssistant from '@/helpers/color-assistant'

// Header shared by the schedule's calendar and list views
export default defineComponent({
  name: 'ScheduleHeader',

  props: {
    label: {
      type: String,
      required: true,
    },
    previousTitle: {
      type: String,
      default: 'Previous',
    },
    nextTitle: {
      type: String,
      default: 'Next',
    },
    hasPrevious: {
      type: Boolean,
      default: true,
    },
    hasNext: {
      type: Boolean,
      default: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['add-task', 'next', 'previous', 'today'],

  data() {
    return {
      ColorAssistant,
    }
  },
})
</script>

<style lang="scss">
.schedule-header {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0 10px 20px;
  border-bottom: 1px solid #dde3ea;
  background-color: var(--color-background-primary);
  color: var(--color-text-secondary);

  &__nav {
    display: flex;
    align-items: center;
    font-weight: 500;
  }

  .nav-button {
    border: none;
    background: none;
    padding: 4px 8px;
    color: var(--color-text-third);
    font-size: 12px;
    cursor: pointer;

    &:hover:not(:disabled) {
      color: var(--color-text-secondary);
    }

    &:disabled {
      opacity: 0.4;
      cursor: default;
    }
  }

  .label {
    margin-left: 8px;
    white-space: nowrap;
  }

  .today-button {
    margin-left: 16px;
    padding: 4px 12px;
    border-radius: 4px;
    border: 1px solid #dde3ea;
    background-color: var(--color-background-primary);
    color: var(--color-text-secondary);
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
  }
}
</style>
